import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import FluidImage from 'components/FluidImage';
import Icon from 'components/Icon';

import css from './WebcamBlock.module.scss';

class WebcamBlock extends React.PureComponent {
    static propTypes = {
        "title": PropTypes.string.isRequired,
        "webcamImageUrl": PropTypes.string.isRequired,
        "webcamErrorLabel": PropTypes.string.isRequired,
        "projectLink": PropTypes.string.isRequired,
        "contentType": PropTypes.string,
        "blockId": PropTypes.oneOf([
            PropTypes.number,
            PropTypes.string
        ])
    }

    state = {
        failed: false,
    }

    componentDidMount() {
        const image = new Image();
        image.onerror = () => {
            this.setState({ failed: true });
        }
        image.src = this.props.webcamImageUrl;
    }

    render() {
        const {
            title,
            webcamImageUrl,
            webcamErrorLabel,
            projectLink,
            anchorName,
        } = this.props;

        const {
            failed,
        } = this.state;

        var anchor = '';

        if (anchorName)
        {
            anchor = '#' + anchorName;
        }

        return (
            <div className={css.block}>
                {projectLink && (
                    <a href={projectLink + anchor}  className={css.link}>
                        {!failed && (
                            <div>
                                <FluidImage
                                    className={css.image}
                                    image={webcamImageUrl}
                                />
                                <div className={css.icon}>
                                    <Icon icon="camera-tripod-24px" />
                                </div>
                            </div>
                        )}
                        {failed && (
                            <div>
                                <div className={cn(css.image, css.failed)}>
                                    <Icon icon="camera-tripod-24px" />
                                    {webcamErrorLabel}
                                </div>
                                <div className={css.icon}>
                                    <Icon icon="camera-tripod-24px" />
                                </div>
                            </div>
                        )}
                    </a>
                )}

                {!projectLink && (
                    <div>
                        {!failed && (
                            <div>
                                <FluidImage
                                    className={css.image}
                                    image={webcamImageUrl}
                                />
                                <div className={css.icon}>
                                    <Icon icon="camera-tripod-24px" />
                                </div>
                            </div>
                        )}
                        {failed && (
                            <div>
                                <div className={cn(css.image, css.failed)}>
                                    <Icon icon="camera-tripod-24px" />
                                    {webcamErrorLabel}
                                </div>
                                <div className={css.icon}>
                                    <Icon icon="camera-tripod-24px" />
                                </div>
                            </div>
                        )}
                    </div>
                )}


                <h3 className={css.title}>{title}</h3>
            </div>
        );
    }
}

export default WebcamBlock;



// WEBPACK FOOTER //
// ./src/components/WebcamBlock/WebcamBlock.jsx